// Keep coordinates as strings so the deep renderer retains the full camera precision.
// Color ranges match the curated previews; fixed bounds keep colors stable while panning.
export const substructurePresets = [
  {
    "id": "spiked-window",
    "title": "Spiked window",
    "description": "A bright, spiked frame branches outward at its corners, with smaller windows repeating along its edges.",
    "initialView": {
      "centerX": "0.969860259438911479833553",
      "centerY": "-1.68154718711592105408543",
      "spanX": "0.000001223376106952013866666666666666666666666666666666666666666666666666667",
      "spanY": "9.175320802140104E-7"
    },
    "colorRange": [
      37.46236027,
      111.22913368
    ],
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "four-lobed-rosette",
    "title": "Four-lobed rosette",
    "description": "Four rounded lobes surround a dark center. Smaller flower-like forms repeat through the surrounding filaments.",
    "initialView": {
      "centerX": "-0.9168467713216052736667837",
      "centerY": "-0.997084111419266377814862",
      "spanX": "1.986821492513020826666666666666666666666666666666666666666666666666667E-8",
      "spanY": "1.49011611938476562E-8"
    },
    "colorRange": [
      73.40244614,
      241.20266861
    ],
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "glowing-grid",
    "title": "Glowing grid",
    "description": "Fine parallel threads cross at a glowing grid, tucked into a tiny region near the western tip of the fractal.",
    "initialView": {
      "centerX": "-1.996381122891396366666113264536",
      "centerY": "-0.000004763309307042618332599667",
      "spanX": "6.14e-10",
      "spanY": "4.605e-10"
    },
    "colorRange": [
      55.46116634,
      128
    ],
    "source": "https://gbillotey.github.io/Fractalshades-doc/examples/batch_mode/12-burning_ship_deep.html",
    "sourceLabel": "Fractalshades zoom example"
  },
  {
    "id": "ribbon-junction",
    "title": "Ribbon junction",
    "description": "Sweeping ribbons meet in a bright knot, with delicate branches tracing their diagonal paths.",
    "initialView": {
      "centerX": "0.971729343437521976929707",
      "centerY": "-1.68176842385288737505904",
      "spanX": "6.116880534760069333333333333333333333333333333333333333333333333333333E-7",
      "spanY": "4.587660401070052E-7"
    },
    "colorRange": [
      34.37335587,
      76.04142883
    ],
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "twin-whirlpools",
    "title": "Twin whirlpools",
    "description": "Two bright cores face each other amid dense, curling filaments that repeat around them.",
    "initialView": {
      "centerX": "-1.743970888819508906340930721",
      "centerY": "-7.581713207154221052979237738e-02",
      "spanX": "1.9402553637822469066666666666666666666666666666666666666666666666666666666666667e-11",
      "spanY": "1.45519152283668518e-11"
    },
    "colorRange": [113, 215],
    "maxRenderPixels": 442368,
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "ember-bridge",
    "title": "Ember bridge",
    "description": "Nested luminous diamonds form a glowing bridge between broad dark chambers.",
    "initialView": {
      "centerX": "-1.907155298414619",
      "centerY": "-0.0021577134836469804",
      "spanX": "0.00010860243003267782",
      "spanY": "0.00008145182252450836"
    },
    "colorRange": [21.9, 56.2],
    "samplesPerPixel": 4
  },
  {
    "id": "crossed-cutlasses",
    "title": "Crossed cutlasses",
    "description": "Two narrow, glowing blades cross at a shallow angle around a small dark diamond, set against a background of dark, ribbed lace.",
    "initialView": {
      "centerX": "-1.743968153085214989924229172",
      "centerY": "-0.07581948058004559988474767083",
      "spanX": "3.8805107275644939e-11",
      "spanY": "2.9103830456733704e-11"
    },
    "colorRange": [
      89.58,
      292.1
    ],
    "maxRenderPixels": 442368,
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "stained-glass-nave",
    "title": "Stained-glass nave",
    "description": "Bright, cross-shaped clusters glow in the lower half of the frame, ringed by dark, arch-shaped cutouts.",
    "initialView": {
      "centerX": "-1.4782252945988842916702057047",
      "centerY": "-0.208656527221592272545655637404",
      "spanX": "6.0632980118195216e-13",
      "spanY": "4.5474735088646412e-13"
    },
    "colorRange": [
      103.05,
      296.2
    ],
    "maxRenderPixels": 442368,
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "gilded-causeway",
    "title": "Gilded causeway",
    "description": "Parallel threads and striped vertical piers stretch across the dark background like a suspension bridge lit up at night.",
    "initialView": {
      "centerX": "1.08196732731670180086767834",
      "centerY": "-1.19995614767316229463044793",
      "spanX": "5.97351614722663e-10",
      "spanY": "4.4801371104199726e-10"
    },
    "colorRange": [
      77.51,
      169.09
    ],
    "maxRenderPixels": 442368,
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "lightning-bridge",
    "title": "Lightning bridge",
    "description": "A bright diagonal arc bridges a grid of thorny filaments, splitting into glowing Y-shaped forks at either end.",
    "initialView": {
      "centerX": "0.9697553011760950196388051",
      "centerY": "-1.681228572906363509473184",
      "spanX": "3.8230503342250435e-08",
      "spanY": "2.8672877506687826e-08"
    },
    "colorRange": [
      41.64,
      81.8
    ],
    "source": "https://mathr.co.uk/bs/2018-01-11_burning_ship_embedded_julia_sets/",
    "sourceLabel": "Claude Heiland-Allen’s embedded Julia gallery"
  },
  {
    "id": "aurora-minaret-skyline",
    "title": "Aurora minaret skyline",
    "description": "Pointed spires rise from a blinding horizon into soft amber curtains of light, casting faint reflections into the dark water below.",
    "width": 1200,
    "height": 900,
    "initialView": {
      "centerX": "-1.659976309867349852068493696534205385550323005740114038",
      "centerY": "-5.5e-39",
      "spanX": "3.31e-38",
      "spanY": "2.4825e-38"
    },
    "colorRange": [
      181,
      196.2
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "solar-prominence-arcade",
    "title": "Solar prominence arcade",
    "description": "A blazing double arc curves down the left horizon while delicate, nested loops of light arch out into the surrounding dark.",
    "width": 1200,
    "height": 900,
    "initialView": {
      "centerX": "-1.9071533297012239830369014387269178",
      "centerY": "-0.0021578971189767673996202664516208",
      "spanX": "2.6666666666666666e-18",
      "spanY": "2e-18"
    },
    "colorRange": [
      366.2,
      481.9
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "crown-of-thorns-sawblade-halo",
    "title": "Crown-of-thorns halo",
    "description": "A jagged ring of thorny filaments encloses a dark moat, with a white-hot star burning at the center.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "0.9177392136767844737549916274210585824435058006",
      "centerY": "-1.4421225180860192883677943043912371128974448417",
      "spanX": "1.9119588200572873e-30",
      "spanY": "1.9119588200572873e-30"
    },
    "colorRange": [
      126.1,
      143.8
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "dragon-wing-sunflower-nexus",
    "title": "Dragon-wing sunflower",
    "description": "Four sweeping, coral-like arms meet at a bright, petal-ringed wheel that divides the dark into four wide bays.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "0.8822247941077734347556808487911704198391",
      "centerY": "-1.7201110799096720057386037618411195138452",
      "spanX": "1.3548127090710468e-23",
      "spanY": "7.620821488524638e-24"
    },
    "colorRange": [
      109.1,
      123.2
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "suspended-lantern-tower-obelisk",
    "title": "Suspended lantern tower",
    "description": "Ribbed towers reach in from top and bottom and flare out at the center into an eight-pointed, web-like lantern suspended between two dark voids.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "-1.8620832981566552769160719997180464951974167421709674016241",
      "centerY": "-0.0114906317092740430147089218488304465331686036516884033539",
      "spanX": "6.436026875925544e-42",
      "spanY": "8.581369167900725e-42"
    },
    "colorRange": [
      142.5,
      170.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "beaded-eight-ray-laser-pulsar",
    "title": "Beaded eight-ray pulsar",
    "description": "Eight straight rays—each strung with tiny, flower-like clusters—shine outward from a white-hot core into the surrounding dark.",
    "initialView": {
      "centerX": "-0.885565550677528207553600485577964129201200382",
      "centerY": "-1.023234580819217933259640835603332371463973428",
      "spanX": "2.8470606090668466e-29",
      "spanY": "2.135295456800135e-29"
    },
    "colorRange": [
      122.4,
      146.8
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "harp-causeway",
    "title": "Harp causeway",
    "description": "Along a glowing causeway in the lower left, a row of striped, fork-tipped towers rises into the dark like the strings and pillars of a harp.",
    "initialView": {
      "centerX": "1.0819673274933338180959629458313032828437",
      "centerY": "-1.1999561477271904587854560762755088557757",
      "spanX": "1.2e-30",
      "spanY": "9e-31"
    },
    "colorRange": [
      506,
      600
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "hyperbolic-spiderweb-cathedral",
    "title": "Spiderweb cathedral",
    "description": "Sweeping, ladder-like arcs curve in from all four corners and meet at a glowing chain of tiny diamonds suspended over the dark.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "-1.9071743231969951059835323792391161596479719439577074412007",
      "centerY": "-0.0036203286221249942794808378492431785815333486939821701117",
      "spanX": "9.717158279985135e-42",
      "spanY": "5.4659015324916385e-42"
    },
    "colorRange": [
      144.1,
      171
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "barred-spiral-star-galaxy",
    "title": "Barred spiral galaxy",
    "description": "Hundreds of tiny, four-pointed stars orbit in nested oval rings around a blazing, tilted core.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "1.0821192780260952856059144690465084",
      "centerY": "-1.2018795060773550639072114646051222",
      "spanX": "5.11780481118352e-18",
      "spanY": "5.11780481118352e-18"
    },
    "colorRange": [
      97.4,
      112.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "orbital-girder-oculus",
    "title": "Orbital girder oculus",
    "description": "Four arched, girder-like bridges converge on a glowing ring that frames a dark circular eye at the center.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "-1.90713992509859267620880988723901008760976653446529913452617620825607099874894852521395428249851412330919331536617860333160952095229348904804779154",
      "centerY": "-0.002159777299302419623131365117852045262953312469251224039498555432981704320295878612140136664652223807708424630329678086771698138940177522541296284",
      "spanX": "1.5e-135",
      "spanY": "1.5e-135"
    },
    "colorRange": [
      685.5,
      716.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "orbital-tripling-hyperbolic-pagoda",
    "title": "Hourglass pagoda",
    "description": "Curving, ladder-like ribs pinch inward like an hourglass around a bright four-pointed heart, with tiered arches stacked above and below.",
    "initialView": {
      "centerX": "-1.9071420726378393685302556",
      "centerY": "-0.0021596010342522516335822",
      "spanX": "1.899143213631119e-9",
      "spanY": "1.4243574102233393e-9"
    },
    "colorRange": [
      62.5,
      94
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "needlepoint-ne-conformal-diamond-rail-star-span",
    "title": "Diamond-rail star span",
    "description": "Paired tracks of light arch outward from a blazing central star, with a chain of dark diamond cutouts set between the rails.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "-1.997963025043411842385517592418921397",
      "centerY": "-0.000015995940066451096936455421522459",
      "spanX": "1.76e-19",
      "spanY": "9.9e-20"
    },
    "colorRange": [
      75.86,
      90.36
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "cloverleaf-arch-corona-180-conformal-trefoil-corona",
    "title": "Cloverleaf corona",
    "description": "A tiny dark ship drifts at the center of a blinding circular halo, ringed by scalloped gold lace and dark, clover-shaped coves.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "-1.76514871778674498338625845657498566712",
      "centerY": "-0.03692747729991836806345216225031763254",
      "spanX": "1.0180220232930473e-22",
      "spanY": "1.0180220232930473e-22"
    },
    "colorRange": [
      266.4,
      341.2
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "falcon-arcade-corona-180-conformal-wing-stela",
    "title": "Falcon-arcade wings",
    "description": "A tiny dark ship sits at the heart of a glowing, web-ringed sun, while four tall, ribbed wings sweep toward the top and bottom of the frame.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "-1.96675242667506327551792217416104605799537",
      "centerY": "-0.00111746909101254018307675480216547981154",
      "spanX": "4.1789672007270084e-25",
      "spanY": "4.1789672007270084e-25"
    },
    "colorRange": [
      140.5,
      171.3
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "spiderweb-palace-ring-nnw-cobweb-rosette-core",
    "title": "Spiderweb-palace core",
    "description": "Scalloped threads spin a delicate cobweb around an eight-pointed star in the lower right, with diamond-patterned ribbons trailing away into the dark.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "-1.86208329809104881725284574960910841937",
      "centerY": "-0.01149063093665505911163534943168930587",
      "spanX": "5.793940837366171e-22",
      "spanY": "7.725254449821561e-22"
    },
    "colorRange": [
      85.5,
      109.1
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "sierpinski-truss-elbow-pm-lightning-star-elbow",
    "title": "Sierpinski lightning truss",
    "description": "A white-hot burst in the lower left sends jagged, branching bolts diagonally across the frame, carving dark triangular gaps between them.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "0.97276663705706281756041219375045877824615",
      "centerY": "-1.68607877097246934692303857574732389779589",
      "spanX": "4.160141158630573e-25",
      "spanY": "4.160141158630573e-25"
    },
    "colorRange": [
      147.2,
      166.4
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "spear-tip-ring-ene-conformal-plasma-star-core",
    "title": "Spear-tip star core",
    "description": "Twin ribbons of light wrap around a blazing star on the left and draw together into a needle-sharp point on the right.",
    "initialView": {
      "centerX": "-1.9990959588889569057428662559126543187",
      "centerY": "-0.0000141455152563262330422687977519669",
      "spanX": "1.7316324996685867e-21",
      "spanY": "1.29872437475144e-21"
    },
    "colorRange": [
      78.5,
      95.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "four-ship-armada-convoy",
    "title": "Four-ship armada",
    "description": "Four dark ships sail in formation along a glowing horizon, each topped with a tall, lacy mast and anchored by a diamond-shaped reflection below.",
    "initialView": {
      "centerX": "-1.9072159778486",
      "centerY": "-0.0021516405340",
      "spanX": "0.000028",
      "spanY": "0.000021"
    },
    "colorRange": [
      28,
      78
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "caustic-prominence-shoreline",
    "title": "Caustic prominence shoreline",
    "description": "A white-hot, jagged cliff meets a pitch-black sea, sending faint, arched ripples of light washing back across the amber shallows.",
    "initialView": {
      "centerX": "-1.74697169856731987190215182586087497529294973416430388949",
      "centerY": "0.00292794617658184782947960207116591963026753308876380587",
      "spanX": "1.6e-44",
      "spanY": "1.2e-44"
    },
    "colorRange": [
      507.5,
      535.1
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "parabolic-plasma-cascade",
    "title": "Parabolic plasma cascade",
    "description": "From a blinding crest near the top of the frame, nested arcs and jagged, thorny filaments pour downward like a waterfall of sparks.",
    "width": 675,
    "height": 1200,
    "initialView": {
      "centerX": "0.9697553099816416117291670167688544461601799347521249696424799060801940252143445789221401141103655672167038130048458517799687011763023088076179253954002459262984875",
      "centerY": "-1.6812285686085280663189532414179814815793716976154044767991498643272426430651147667469912482017043094882925550057643105045703818281390747329125088686755346666557009304",
      "spanX": "1.5e-150",
      "spanY": "2.6666666666666666e-150"
    },
    "colorRange": [
      1217.5,
      1239.8
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "supernova-ray-hub",
    "title": "Supernova ray-hub",
    "description": "Fine golden rays stream outward from a blinding oval core, ringed by dark, beaded shadow-spokes that reach into the surrounding ember dust.",
    "initialView": {
      "centerX": "-1.780425137323272787815501970866799220117789164950755824065998180804054216718401083082315480682414200942106597271163774688928189276668834162257864725732897228477210166344966847497073401",
      "centerY": "-0.06500377933325755658690166726343568470341357651166253908409608154945176557553463044202701111297831544836546730208444477432975243227800009643123524287621756484090422114572084021112115151",
      "spanX": "1e-150",
      "spanY": "7.5e-151"
    },
    "colorRange": [
      2617.1,
      2687.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "koch-snowflake-lagoon",
    "title": "Koch snowflake lagoon",
    "description": "A dark, star-shaped lagoon lies encircled by a glowing reef of crystalline, snowflake-like branches.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "0.969859985097974856073871129661690888584991516800893004621763526755452642457515737470976903",
      "centerY": "-1.681547143361954407926033757707379920992927290236233010284074667784694884996553080967736555",
      "spanX": "1.5e-78",
      "spanY": "1.5e-78"
    },
    "colorRange": [
      306.5,
      322.1
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "snowflake-bastion-plasma-cross",
    "title": "Snowflake plasma cross",
    "description": "Four glowing arms meet at a bright crossroads, with intricate, snowflake-like bastions filling each of the four corners.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "0.88148327515264465197001420937767824106470674004255752528847538659226442932305262",
      "centerY": "-1.72177723795731885368553073231402734953261035225318639076908862722314539990965649",
      "spanX": "5.44982607650007e-64",
      "spanY": "7.26643476866676e-64"
    },
    "colorRange": [
      300.1,
      313.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "ember-candelabra",
    "title": "Ember candelabra",
    "description": "A glowing candelabrum of branching crosses rises into the dark around a tiny black ship at its center.",
    "initialView": {
      "centerX": "-1.780425137323272787815501970866799220117789164950755824065998181134054217",
      "centerY": "-0.065003779333257556586901667263435684703413576511662539084096078749451766",
      "spanX": "1.6e-62",
      "spanY": "1.2e-62"
    },
    "colorRange": [
      615,
      1480
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "floating-three-eye-crown",
    "title": "Floating three-eye crown",
    "description": "A glowing horizontal crown with three dark, diamond-shaped eyes floats isolated in the dark.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "0.819341363531612847084887656217116062635",
      "centerY": "-1.5640658234185376778767671694126529594528",
      "spanX": "1.1008717987661151e-24",
      "spanY": "6.1924038680593975e-25"
    },
    "colorRange": [
      65.5,
      84.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "ember-sigil-iv",
    "title": "Ember sigil",
    "description": "Two parallel diagonal bands of bright, cross-shaped sparks mirror each other across a textured field of dark embers and cutouts.",
    "initialView": {
      "centerX": "-1.47822545879098827688710370464313",
      "centerY": "-0.20865649008144561355507530164412",
      "spanX": "1.4e-22",
      "spanY": "1.05e-22"
    },
    "colorRange": [
      462.3,
      659.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "floating-crest-gossamer-suspension",
    "title": "Floating gossamer crest",
    "description": "A bright, butterfly-winged emblem hangs across the dark, held in place by fine diagonal threads of lace.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "0.971503756760639392372607",
      "centerY": "-1.6822630585780437385112032",
      "spanX": "1.8398069465241627e-9",
      "spanY": "1.0348914074198415e-9"
    },
    "colorRange": [
      56.2,
      94.1
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "parabolic-cascade-spiked-monstrance",
    "title": "Spiked monstrance",
    "description": "Eight thorny spokes radiate from a blazing, rectangular crown suspended in the dark.",
    "width": 675,
    "height": 1200,
    "initialView": {
      "centerX": "0.969456966663607299972464875",
      "centerY": "-1.680865675878575614860324626",
      "spanX": "5.441762980053133e-11",
      "spanY": "9.674245297872237e-11"
    },
    "colorRange": [
      55.2,
      76.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "imperial-crown-parabolic-pearl-court",
    "title": "Imperial pearl court",
    "description": "A single bright pearl glows inside a thorny square frame, flanked on either side by sweeping, ribbed arches.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "0.969860327583556710131934527193",
      "centerY": "-1.681547265163762947750310335358",
      "spanX": "3.002547587661377e-14",
      "spanY": "3.002547587661377e-14"
    },
    "colorRange": [
      176.9,
      250.3
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "bioluminescent-twin-wing-torch",
    "title": "Twin-wing torch",
    "description": "A bright diagonal core burns between two symmetrical, snowflake-lace wings against the dark.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "0.880544415137181925922748603215849004",
      "centerY": "-1.719273218058468707845216058141658077",
      "spanX": "4.3628559105171746e-20",
      "spanY": "4.3628559105171746e-20"
    },
    "colorRange": [
      80.3,
      92.6
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "cloverleaf-five-star-suspension-vault",
    "title": "Five-star suspension vault",
    "description": "Five bright, eight-pointed star lanterns are linked along a diagonal truss between sweeping, web-like cables.",
    "initialView": {
      "centerX": "-1.9071332200851131691108303157772",
      "centerY": "-0.0021970569171226161306712039431",
      "spanX": "4.840754424645278e-15",
      "spanY": "3.6305658184839585e-15"
    },
    "colorRange": [
      119.2,
      147
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "west-compass-ne-braided-neon-eyelet-compass",
    "title": "Braided eyelet compass",
    "description": "An eight-pointed star in the lower left sits inside a ring of diamond eyelets, connected to ribbed, tower-like struts along the upper left and lower right.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "-1.94197317050105996183544107892194025864",
      "centerY": "-0.00765886258730214434908112428870924811",
      "spanX": "1.1825236167375118e-22",
      "spanY": "1.5766981556500157e-22"
    },
    "colorRange": [
      78.5,
      99.4
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "sierpinski-truss-outer-island-lightning-star-cross",
    "title": "Lightning star cross",
    "description": "Four jagged, triangular trusses cross at a blazing central cluster, reaching outward between wide dark bays.",
    "initialView": {
      "centerX": "0.97276663705706281756041338357548498428982",
      "centerY": "-1.68607877097246934692303876050636297395416",
      "spanX": "3.6004152575840453e-25",
      "spanY": "2.700311443188034e-25"
    },
    "colorRange": [
      145.1,
      158.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "inner-colonnade-great-grandchild-horizontal-bipolar-twin-hubs",
    "title": "Scalloped cobweb canopy",
    "description": "Two bright star clusters glow inside a mask-like arch near the bottom of the frame, while scalloped cobweb rings and double-tracked suspension cables fan outward across the dark.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "-1.810315008476882205127981339241791920330797713825866607613029",
      "centerY": "-0.004434054944116325653669661453566219919748025290175901674974",
      "spanX": "2.019415716774725e-42",
      "spanY": "1.1359213406857828e-42"
    },
    "colorRange": [
      279.3,
      322.7
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "cartouche-chasm-great-grandchild-horizontal-bipolar-twin-hubs",
    "title": "Coral-lace chasm and twin knots",
    "description": "Two blazing oval knots glow within a dense thicket of coral-like lace on the right, while jagged, branching filaments reach diagonally across a dark chasm toward the upper left.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "0.833167299395398562767666897816784214560806442534055271990909",
      "centerY": "-1.679714200349270004951477483109079797103586708076779900118892",
      "spanX": "2.5008267474843354e-42",
      "spanY": "1.4067150454599387e-42"
    },
    "colorRange": [
      286.5,
      307.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "cellular-reef-grandchild-landscape-quincunx-matrix",
    "title": "Thorny reef medallion",
    "description": "A blazing oval medallion of lacy cells glows at the center where a fine horizontal thread crosses a wide diagonal lattice of thorny branches between two dark bays.",
    "initialView": {
      "centerX": "0.970145848625348023074649252638305767162529735346517182",
      "centerY": "-1.682081082756175347680651603660422156919152048537719149",
      "spanX": "8.86316790136161e-35",
      "spanY": "6.647375926021208e-35"
    },
    "colorRange": [
      328.5,
      353.4
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "spear-point-great-grandchild-landscape-quincunx-matrix",
    "title": "Sunburst eye mandala",
    "description": "Centered in the frame, a blazing tilted eye with a four-pointed star at its pupil radiates scalloped petals, diamond cutouts, and double-tracked ribs into the surrounding dark coves.",
    "initialView": {
      "centerX": "-1.999095958888956905749872979509970710938834124301838383008730212456",
      "centerY": "-0.000014145515256326239343964915690947538379922183039377169432324115",
      "spanX": "1.3009566653659338e-47",
      "spanY": "9.757174990244503e-48"
    },
    "colorRange": [
      287.4,
      308.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "matryoshka-square-diamond-yantra",
    "title": "Spiked diamond medallion",
    "description": "A blazing, spiked diamond ring surrounds a bright central star, while delicate, thorny branches weave a diagonal lattice across the surrounding dark.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "0.969909480409616344769609100629",
      "centerY": "-1.681665187820413051198525931372",
      "spanX": "1.9955322832029247e-13",
      "spanY": "2.660709710937233e-13"
    },
    "colorRange": [
      98.3,
      131.2
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "starkite-diamond-portrait-quincunx-matrix",
    "title": "Star-kite constellation",
    "description": "A bright central star burns inside a tilted, kite-shaped ring of smaller four-pointed stars and snowflake-like clusters, set along a diagonal beam of amber light.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "1.116244246865542041649387821188931726571955579",
      "centerY": "-1.258763558294874887340335924253380889754175494",
      "spanX": "1.4109979445563563e-29",
      "spanY": "1.8813305927418084e-29"
    },
    "colorRange": [
      150.8,
      164.3
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "silk-vortices",
    "title": "Figure-eight silk vortices",
    "description": "Two white-hot vortices glow at opposite ends of a figure-eight chamber, wrapped in sweeping contours of amber silk and dark, scalloped lace.",
    "width": 1200,
    "height": 1200,
    "initialView": {
      "centerX": "-1.996381122925929653294037828311253469966641852551354028279745849996384561656543300231734846372389",
      "centerY": "-0.000004763303728392770746014692362029865866711691612095974571331721507794709607604050981467065737",
      "spanX": "2.2e-86",
      "spanY": "2.2e-86"
    },
    "colorRange": [
      3376,
      3550
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "axis-spire",
    "title": "Axis spire",
    "description": "A tall, twin-tipped spire with flared crossbars rises above a glowing horizon of smaller towers, casting a faint reflection into the dark below.",
    "initialView": {
      "centerX": "-1.66",
      "centerY": "-0.0055",
      "spanX": "0.02",
      "spanY": "0.015"
    },
    "colorRange": [
      12.56,
      39.48
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "barred-galaxy-diagonal-starfighter-squadron",
    "title": "Diagonal starfighter squadron",
    "description": "Dozens of glowing, cross-winged starships fly in tight diagonal formation along faint amber trails across the dark.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "1.0821192780",
      "centerY": "-1.2018795061",
      "spanX": "0.00009493333333333333",
      "spanY": "0.0000534"
    },
    "colorRange": [
      19,
      33.5
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "solar-eclipse-parabolic-crescent-bay",
    "title": "Solar-eclipse crescent bay",
    "description": "A pitch-black bay along the upper shoreline of the largest ship is rimmed by a white-hot corona and horizontal rays of amber light.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "-1.7469716986",
      "centerY": "0.0029279462",
      "spanX": "0.006499555555555555",
      "spanY": "0.003656"
    },
    "colorRange": [
      18.5,
      42
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "celtic-knot-parabolic-arch-bridge",
    "title": "Celtic-knot arch bridge",
    "description": "A blazing core on the left sends a curved, thorny spine arching across a wide dark bay, surrounded by interlocking loops of golden lace.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "0.957523638283783330785472117343289",
      "centerY": "-1.658479590912737453964024378426277",
      "spanX": "9.418539318683061e-17",
      "spanY": "5.2979283667592216e-17"
    },
    "colorRange": [
      95.4,
      114.7
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "bowtie-plasma-searchlight-iris",
    "title": "Bowtie searchlight iris",
    "description": "A tiny dark ship sits at the center of a blinding bowtie flare, sending tiered beams of golden lace outward between two dark bays.",
    "width": 1200,
    "height": 675,
    "initialView": {
      "centerX": "0.968212321572614514734010975863978021325",
      "centerY": "-1.656347076418085315934179830679639927141",
      "spanX": "1.8102553766374043e-23",
      "spanY": "1.0182686493585399e-23"
    },
    "colorRange": [
      91.5,
      118.4
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "bioluminescent-branching-lightning-crown",
    "title": "Branching lightning spine",
    "description": "A blazing vertical spine cuts through the dark, sending out angled, thorny crossbars at regular intervals.",
    "width": 900,
    "height": 1200,
    "initialView": {
      "centerX": "0.9464554939128918005528019630923",
      "centerY": "-1.6393090025598248706725120299157",
      "spanX": "9.703447966573825e-15",
      "spanY": "1.2937930622098433e-14"
    },
    "colorRange": [
      63.4,
      78.4
    ],
    "maxRenderPixels": 442368
  },
  {
    "id": "spear-tip-five-hub-conformal-court",
    "title": "Spear-tip diamond court",
    "description": "Sweeping double-tracked rails curve around a blazing central cross, framing nested diamond eyelets to the left and right and V-shaped chevrons above and below.",
    "initialView": {
      "centerX": "-1.99909595888895690574323481282981351116",
      "centerY": "-0.000014145515256326232884315833255170177",
      "spanX": "5.613304464691024e-20",
      "spanY": "4.209978348518268e-20"
    },
    "colorRange": [
      73.5,
      85.6
    ],
    "maxRenderPixels": 442368
  }
];

const OVERVIEW_SPAN_FLOOR = 1e-3;
const DEEP_ZOOM_SPAN_FLOOR = 1e-16;
const ABYSSAL_ZOOM_SPAN_FLOOR = 1e-38;

export const overviewPresets = substructurePresets.filter(
  preset => Number(preset.initialView.spanX) >= OVERVIEW_SPAN_FLOOR
);

export const deepZoomPresets = substructurePresets.filter(
  preset => {
    const spanX = Number(preset.initialView.spanX);
    return spanX < OVERVIEW_SPAN_FLOOR && spanX >= DEEP_ZOOM_SPAN_FLOOR;
  }
);

export const abyssalZoomPresets = substructurePresets.filter(
  preset => {
    const spanX = Number(preset.initialView.spanX);
    return spanX < DEEP_ZOOM_SPAN_FLOOR && spanX >= ABYSSAL_ZOOM_SPAN_FLOOR;
  }
);

export const chthonicZoomPresets = substructurePresets.filter(
  preset => Number(preset.initialView.spanX) < ABYSSAL_ZOOM_SPAN_FLOOR
);
